import template from './enter-email.jade';
import validation from '../../../scripts/services/validation';

export default () => {
  return {
    require: ['cianAfEnterEmail', 'form'],
    bindToController: {
      enterEmailData: '=',
      mergeData: '=',
    },
    link: (scope, element, attrs, ctrls) => {
      ctrls[0].init(ctrls[1]);
    },
    template,
    controller: function ($scope, apiService, analyticsService, remoteValidationService, popupService, authService, deviceService) {
        'ngInject';

        this.isMobile = deviceService.isMobile;

        const sendAuthAnalytics = (isLogin, type) => {
          if (authService.isLastStepLogin) {
            if (isLogin) {
              analyticsService.successfulSocLogin(type);
            } else {
              analyticsService.successfulSocRegistration(type);
            }
          } else {
            if (type === 'mailru') type = 'mail';
            if (isLogin) {
              analyticsService.successSocialAuth(type);
            } else {
              analyticsService.successSocialRegister(type);
            }
          }
        };

        this.email = '';
        this.socialTypes = {
          vk: '"ВКонтакте"',
          fb: 'Facebook',
          ok: '"Одноклассники"',
          google: 'Google+',
          mailru: 'Mail.ru',
        };

        this.mergeAccount = () => {
          const data = this.enterEmailData;
          const dataForMergeAccount = {
            visible: true,
            mergeEmail: this.email,
            socialLoginId: data.socialLoginId,
          };
          if (this.enterEmailData.socialType) {
            dataForMergeAccount.type = this.enterEmailData.socialType === 'mailru' ?
              'mail' : this.enterEmailData.socialType
          }
          this.mergeData = dataForMergeAccount;
          this.clearForm();
          this.enterEmailData = {
            visible: false
          };
        };

        this.init = form => {
          this.emailValidation = validation(form, 'email', {
            required: 'Не заполнен "E-mail"',
          });

          form.remoteValidator = remoteValidationService.getInstance(form);
          form.remoteValidator.map = data => {
            const result = {
              fields: {},
              form: {},
              sections: {},
            };
            if (data.key === 'email') {
              result.fields.email = {
                triggers: 'email',
                messages: data,
              };
            }
            return result;
          };

          this.clearForm = () => {
            this.email = '';
            form.$setPristine();
            form.email.$setUntouched();
          };

          this.showError = options => {
            const popupData = options || {};
            popupService.openPopup('authError', { popupData });
          };

          this.skipEntering = () => {
            if (!this.submiting) {
              this.submiting = true;
              const data = {
                socialLoginId: this.enterEmailData.socialLoginId
              };
              apiService.generateFakeEmail(data)
                .then(generateMailResponse => {
                  const data = {
                    socialLoginId: this.enterEmailData.socialLoginId,
                    email: generateMailResponse.data.email
                  };
                  return apiService.socialMergeNew(data);
                })
                .then(mergeResponse => {
                  const data = {
                    socialLoginId: mergeResponse.data.socialLoginId,
                    email: mergeResponse.data.email,
                    token: mergeResponse.data.token
                  };
                  return apiService.socialLogin(data);
                })
                .then(() => {
                  const { type } = this.enterEmailData;
                  sendAuthAnalytics(false, type);
                  return authService.getUserData();
                })
                .catch(response => {
                  this.submiting = false;
                  const error = response.data.errors[0];
                  this.showError({ message: error.message });
                });
            }
          };

          this.submiting = false;
          this.submit = () => {
            form.email.$setTouched();
            this.submiting = true;
            const data = {
              socialLoginId: this.enterEmailData.socialLoginId,
              email: this.email
            };

            apiService.socialMergeNew(data)
              .then(response => {
                const data = {
                  socialLoginId: response.data.socialLoginId,
                  email: response.data.email,
                  token: response.data.token
                };
                return apiService.socialLogin(data);
              })
              .then(() => {
                const { type } = this.enterEmailData;
                sendAuthAnalytics(false, type);
                return authService.getUserData();
              })
              .catch(response => {
                this.submiting = false;
                const error = response.data.errors[0];
                if (error.key === 'existed_email') {
                  this.mergeAccount();
                } else if (error.key === 'email') {
                  form.remoteValidator.setValidators(error);
                } else {
                  this.showError({ message: error.message });
                }
              });
          };
        };
      },
    controllerAs: 'enterEmailCtrl',
    replace: true,
  };
};
